import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  search() {
    const q = this.inputTarget.value.trim().toLowerCase()
    const list = document.getElementById("conversations_list")
    if (!list) return

    list.querySelectorAll(".conversation-item").forEach(item => {
      const name = (item.dataset.userName || item.textContent).toLowerCase()
      item.style.display = name.includes(q) || q === "" ? "" : "none"
    })
  }
}
